import "./App.css";
import CheckoutPage from "./CheckoutPage.js";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from "./HomePage.js";
import Home from "./Home";
import Login from "./Login.js";
import { useEffect } from "react";
import { auth } from "./firebase";
import { useStateValue } from "./StateProvider";
import { onAuthStateChanged } from "firebase/auth";


function App() {
  const [{}, dispatch] = useStateValue();

  useEffect(() => {
      auth.onAuthStateChanged((authUser) => {
        if (authUser) {
          dispatch({
            type: 'SET_USER',
            user: authUser
          })
        }
        else
        {
          dispatch({
            type: 'SET_USER',
            user: null
          })
        }
        
      console.log("THE USER IS >>>", authUser);
      })

  }, [])
  return (
    <Router>
      <div className="app">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/checkout" element={<CheckoutPage />}></Route>
          <Route path="/" element={<HomePage />}></Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;
